export default {
    "welcome": {
        "title": "Bienvenue ? ProcrastiQ",
        "subtitle": "Votre compagnon de productivit?",
        "modal": {
            "title": "Bienvenue ? ProcrastiQ",
            "headline": "Des pauses intelligentes pour ton cerveau",
            "subheading": "Des en-cas pour le cerveau, des faits et des moments de conscience qui transforment les minutes libres en quelque chose de significatif. ",
            "text": "Procrastiq est l? que la procrastination devient quelque chose de significatif. Au lieu de faire d?filer sans fin les r?seaux sociaux, vous d?couvrirez des snacks rapides con?us pour divertir, stimuler votre esprit, et peut-?tre m?me vous apprendre quelque chose de nouveau. \n\nIl ne s?agit pas de productivit? ? tout prix. Tout le monde a besoin d?un moment pour faire une pause, se ressourcer et s??loigner du travail. Procrastiq vous aide ? transformer ces petites pauses en quelque chose de positif ? rempli de curiosit?, de plaisir et d?entra?nement c?r?bral quotidien. De petits d?fis. De grands progr?s. ",
            "cta": "Allons-y"
        }
    },
    "login": {
        "title": "Connexion",
        "email": "Email",
        "password": "Mot de passe",
        "submit": "Connexion",
        "cancel": "Annuler",
        "success": "Connexion r?ussie",
        "lead": "Bienvenue ? nouveau ? relance ta s?rie et grimpe dans les ligues. "
    },
    "logout": "D?connexion",
    "logo": {
        "title": "ProcrastiQ",
        "slogan": "Des pauses intelligentes pour ton cerveau"
    },
    "register": {
        "title": "Registre",
        "name": "Nom",
        "email": "Email",
        "password": "Mot de passe",
        "submit": "Cr?er un compte",
        "cancel": "Annuler",
        "success": "Enregistrement r?ussi",
        "country": "Pays",
        "lead": "Cr?ez un compte pour gagner de l?XP, d?bloquer des rangs et rejoindre des ligues hebdomadaires. "
    },
    "social": {
        "divider": "Ou continuer avec",
        "signInWith": "Connectez-vous avec {{provider}}",
        "continueWith": "Continuez avec {{provider}}",
        "failed": "?chec de connexion sociale",
        "popup_blocked": "La fen?tre pop-up a ?t? bloqu?e. Veuillez autoriser les fen?tres pop-up et r?essayer. ",
        "cancelled": "La connexion a ?t? annul?e. "
    },
    "common": {
        "cancel": "Annuler",
        "saving": "Sauver... ",
        "unknown_error": "Erreur inconnue",
        "select_country": "Pays s?lectionn?",
        "select_option": "S?lectionnez une option",
        "country": "Pays"
    },
    "language": {
        "page_language": "Langue des pages",
        "switch_to": "Passer ? {{language}}"
    },
    "cookies": {
        "title": "Cookies",
        "message": "Nous utilisons des cookies d'analyse (Google Analytics) pour am?liorer Procrastiq.",
        "privacy_link": "Politique de confidentialit?",
        "accept": "Accepter",
        "reject": "Refuser"
    },
    "footer": {
        "columns": {
            "about": {
                "title": "? propos de nous",
                "mission": "Mission",
                "progression": "XP, niveaux et ligues",
                "creator_progression": "XP des cr?ateurs & rangs",
                "contact": "Contactez-nous"
            },
            "leaderboards": {
                "title": "Classements",
                "players": "Membres",
                "creators": "Contributeurs"
            },
            "legal": {
                "title": "Confidentialit? et Conditions d?utilisation",
                "community": "Directives communautaires",
                "terms": "Conditions d?utilisation",
                "privacy": "Politique de confidentialit?"
            },
            "social": {
                "title": "Social",
                "facebook": "Facebook",
                "instagram": "Instagram"
            }
        }
    },
    "pages": {
        "mission": {
            "title": "Mission",
            "content": "ProcrastiQ transforme les petites pauses en moments significatifs ? encas c?r?braux, ?nigmes et pauses conscientes qui divertissent et stimulent votre esprit.\n\nNous croyons que la procrastination n'a pas ? ?tre du temps perdu. Tout le monde m?rite un moment pour se ressourcer, et nous aidons ? rendre ces moments positifs, curieux et amusants."
        },
        "contact": {
            "title": "Contactez-nous",
            "content": "Vous avez une question, une id?e d?am?lioration, ou vous avez crois? quelque chose qui ne fonctionne pas comme pr?vu ? ?crivez-nous ? chaque retour nous aide ? am?liorer Procrastiq.\n\nVous pouvez nous ?crire ? :\n\nhello@procrastiq.com\n\nNous lirons aussi volontiers vos suggestions de nouveaux contenus, fonctionnalit?s ou th?mes que vous aimeriez voir sur Procrastiq."
        },
        "community": {
            "title": "Directives de la communaut?",
            "content": "ProcrastiQ est un espace accueillant pour les esprits curieux. Soyez respectueux, aimable et constructif dans vos interactions.\n\nNe publiez pas de contenu nuisible, abusif ou spam. Signalez tout ce qui ne convient pas. Ensemble, nous gardons cet espace positif pour apprendre et faire des pauses intelligentes."
        },
        "terms": {
            "title": "Conditions d'utilisation",
            "content": "**Derni?re mise ? jour : 7 septembre 2026**\n\nEn utilisant le service Procrastiq, vous acceptez les pr?sentes conditions. Si vous n??tes pas d?accord, veuillez ne pas utiliser le service.\n\n## 1. ? propos de Procrastiq\n\nProcrastiq est une plateforme en ligne d?di?e ? l?apprentissage, aux quiz, aux ?nigmes et ? d?autres contenus interactifs.\n\nLe contenu du service est destin? principalement ? l??ducation et au divertissement. Il ne constitue pas un conseil professionnel, juridique, m?dical, financier ou autre conseil sp?cialis?.\n\n## 2. Compte utilisateur\n\nCertaines fonctionnalit?s de Procrastiq peuvent n?cessiter la cr?ation d?un compte utilisateur.\n\nVous ?tes responsable de l?exactitude des informations de votre compte et de la s?curit? de vos identifiants.\n\nUn compte ne doit pas ?tre utilis? pour violer les droits d?autrui, la loi applicable ou les pr?sentes conditions.\n\n## 3. R?gles d?utilisation\n\nLors de l?utilisation de Procrastiq, il est notamment interdit de :\n\n* publier un contenu ill?gal, frauduleux, haineux ou autrement nuisible,\n* porter atteinte au droit d?auteur ou ? d?autres droits de tiers,\n* harceler d?autres utilisateurs,\n* tenter de perturber la s?curit? ou le fonctionnement du service,\n* collecter automatiquement du contenu ou des donn?es d?une mani?re que nous n?autorisons pas,\n* abuser des ?valuations, de l?XP, des classements ou d?autres m?canismes de jeu.\n\n## 4. Contenu utilisateur\n\nLes utilisateurs peuvent cr?er ou soumettre leur propre contenu, par exemple des quiz, des questions, des commentaires ou d?autres contributions.\n\nEn soumettant du contenu, vous confirmez que vous avez le droit de le publier.\n\nVous conservez vos droits sur votre contenu. Dans le m?me temps, vous nous accordez un droit non exclusif de stocker, afficher, adapter techniquement et mettre ce contenu ? disposition au sein de Procrastiq dans la mesure n?cessaire au fonctionnement du service.\n\n## 5. Mod?ration du contenu\n\nNous pouvons examiner le contenu des utilisateurs et, en cas de violation des pr?sentes conditions ou de la loi applicable, le refuser, le masquer ou le supprimer.\n\nEn cas de manquements graves ou r?p?t?s, nous pouvons restreindre ou r?silier un compte utilisateur.\n\nLorsque les circonstances le permettent et que la loi l?exige, nous informons l?utilisateur du motif d?une telle d?cision.\n\n## 6. Contenu Procrastiq\n\nLe contenu publi? directement par Procrastiq peut contenir des erreurs ou des inexactitudes. Bien que nous cherchions ? v?rifier et ? am?liorer continuellement les informations, nous ne pouvons garantir leur exhaustivit? ni l?absence d?erreurs.\n\nLes quiz et autres contenus ?ducatifs ont avant tout un caract?re informatif et r?cr?atif.\n\n## 7. Disponibilit? du service\n\nNous nous effor?ons de maintenir Procrastiq disponible et fonctionnel, mais nous ne pouvons garantir un fonctionnement ininterrompu ou sans erreur.\n\nNous pouvons modifier, ?tendre ou interrompre certaines parties du service au fil du temps.\n\n## 8. Responsabilit?\n\nDans la mesure permise par la loi applicable, nous ne sommes pas responsables des dommages r?sultant d?une utilisation incorrecte du service ou de la confiance accord?e ? un contenu purement informatif ou ?ducatif.\n\nCela n?affecte pas les droits des utilisateurs qui ne peuvent pas ?tre limit?s en vertu de la loi applicable.\n\n## 9. Confidentialit?\n\nDes informations sur le traitement des donn?es personnelles sont disponibles dans notre [Politique de confidentialit?](/legal/privacy).\n\n## 10. Modifications des pr?sentes conditions\n\nNous pouvons mettre ? jour ces conditions de temps ? autre, par exemple en raison de changements du service, de la l?gislation ou du fonctionnement de Procrastiq.\n\nLa date de la derni?re mise ? jour figurera toujours en haut de cette page. Nous pouvons ?galement informer les utilisateurs des changements importants via le service ou par e-mail.\n\n## 11. Contact\n\nPour toute question concernant ces conditions, vous pouvez nous contacter ? :\n\n[hello@procrastiq.com](mailto:hello@procrastiq.com)"
        },
        "privacy": {
            "title": "Politique de confidentialit?",
            "content": "**Derni?re mise ? jour : 7 septembre 2026**\n\nNous prenons votre vie priv?e au s?rieux. Ci-dessous, nous expliquons quelles donn?es personnelles nous traitons lorsque vous utilisez Procrastiq, pourquoi nous en avons besoin et quels sont vos droits.\n\n## 1. Qui traite les donn?es\n\nLe responsable du traitement des donn?es personnelles est :\n\n**Michal Orl?k**\npersonne physique\n\nContact pour les questions relatives ? la protection des donn?es personnelles :\n\n**[hello@procrastiq.com](mailto:hello@procrastiq.com)**\n\n## 2. Quelles donn?es nous traitons\n\nSelon la fa?on dont vous utilisez Procrastiq, nous pouvons traiter notamment :\n\n* les donn?es de votre compte, par exemple le nom, le nom d'utilisateur et l'adresse e-mail,\n* les donn?es obtenues lors de la connexion via un service externe, par exemple Google,\n* les informations sur l'utilisation du service, par exemple le contenu consult?, les r?sultats des quiz, les XP obtenus, les s?ries, les r?actions, les favoris et l'activit? dans le fil,\n* le contenu que vous cr?ez ou envoyez vous-m?me,\n* les donn?es techniques, par exemple l'adresse IP, le type d'appareil, le navigateur et les informations n?cessaires ? la s?curit? et au bon fonctionnement du service.\n\n## 3. Pourquoi nous utilisons les donn?es\n\nNous utilisons les donn?es personnelles principalement pour :\n\n* cr?er et g?rer votre compte,\n* fournir les fonctionnalit?s de Procrastiq,\n* enregistrer votre progression, vos r?sultats, vos XP et votre autre activit?,\n* personnaliser le contenu et les recommandations,\n* prot?ger le service contre les abus,\n* r?soudre les erreurs et les probl?mes techniques,\n* communiquer avec vous,\n* analyser et am?liorer le fonctionnement du service.\n\n## 4. Base juridique du traitement\n\nNous traitons les donn?es selon chaque finalit? principalement :\n\n* parce qu'elles sont n?cessaires ? la fourniture du service,\n* sur la base de notre int?r?t l?gitime ? s?curiser et am?liorer Procrastiq,\n* sur la base de votre consentement lorsque le consentement est requis,\n* ou pour respecter des obligations l?gales.\n\nSi le traitement est fond? sur le consentement, vous pouvez le retirer ? tout moment.\n\n## 5. ? qui les donn?es peuvent ?tre transmises\n\nNous ne vendons pas vos donn?es personnelles.\n\nPour faire fonctionner le service, nous pouvons toutefois faire appel ? des prestataires externes, par exemple pour :\n\n* l'h?bergement et l'infrastructure,\n* l'authentification des utilisateurs,\n* l'envoi d'e-mails et de notifications,\n* l'analytique et le diagnostic des erreurs.\n\nCes prestataires ne peuvent traiter les donn?es que dans la mesure n?cessaire ? la fourniture de leurs services.\n\n## 6. Combien de temps nous conservons les donn?es\n\nLes donn?es li?es ? votre compte sont g?n?ralement conserv?es pendant la dur?e d'existence du compte, puis pendant la dur?e n?cessaire au respect des obligations l?gales ou ? la protection de nos int?r?ts l?gitimes.\n\nLes donn?es techniques et analytiques ne sont conserv?es que pendant la dur?e n?cessaire ? leur finalit?.\n\n## 7. Vos droits\n\nDans le cadre du traitement des donn?es personnelles, vous avez selon les circonstances le droit de :\n\n* obtenir des informations sur les donn?es que nous traitons vous concernant,\n* demander la rectification de donn?es inexactes,\n* demander l'effacement de donn?es,\n* demander la limitation du traitement,\n* vous opposer ? certaines formes de traitement,\n* recevoir vos donn?es dans un format portable,\n* retirer le consentement donn?.\n\nVous pouvez envoyer une demande ? :\n\n**[hello@procrastiq.com](mailto:hello@procrastiq.com)**\n\nNous r?pondons aux demandes conform?ment ? la l?gislation applicable.\n\n## 8. Suppression du compte\n\nSi le service permet la suppression du compte, vous pouvez demander sa suppression directement dans les param?tres du compte ou nous contacter ? **[hello@procrastiq.com](mailto:hello@procrastiq.com)**.\n\nLors de la suppression du compte, nous supprimons ou anonymisons les donn?es personnelles que nous n'avons plus besoin de conserver pour des raisons juridiques ou de s?curit?.\n\n## 9. Cookies et technologies similaires\n\nProcrastiq peut utiliser des cookies et des technologies similaires n?cessaires ? la connexion, ? la s?curit?, ? l'enregistrement des param?tres et ?ventuellement ? l'analytique.\n\nDes informations plus d?taill?es sur les cookies peuvent figurer dans une politique de cookies distincte.\n\n## 10. S?curit?\n\nNous utilisons des mesures techniques et organisationnelles appropri?es pour prot?ger les donn?es personnelles contre l'acc?s non autoris?, la perte ou l'utilisation abusive.\n\nAucun syst?me ne peut toutefois ?tre consid?r? comme absolument s?r.\n\n## 11. R?clamation\n\nSi vous estimez que nous traitons vos donn?es personnelles en violation de la l?gislation applicable, vous pouvez ?galement vous adresser ? l'autorit? de contr?le comp?tente.\n\nEn R?publique tch?que, il s'agit du **Office de la protection des donn?es personnelles (??ad pro ochranu osobn?ch ?daj?)**.\n\n## 12. Modifications de cette politique\n\nNous pouvons mettre ? jour cette politique de temps ? autre, par exemple en lien avec de nouvelles fonctionnalit?s ou des ?volutions juridiques.\n\nLa date de la derni?re mise ? jour figurera toujours en haut de cette page."
        },
        "progression": {
            "title": "XP, niveaux et ligues",
            "content": "ProcrastiQ r?compense la curiosit?. R?pondez aux quiz, cr?ez des s?ries, et progressez des encas c?r?braux occasionnels ? la comp?tition hebdomadaire.\n\n## Points d'exp?rience (XP)\n\nVous gagnez des XP permanents lorsque vous jouez bien ? par exemple, r?ponses correctes, bonus d?s le premier essai, questions plus difficiles, r?visions et objectifs quotidiens. Les XP permanents ne se r?initialisent jamais et comptent toujours pour votre niveau.\n\nIl existe ?galement des XP class?s utilis?s uniquement pour les ligues hebdomadaires. Les XP class?s utilisent des rendements d?croissants quotidiens : les premiers XP de la journ?e comptent pleinement, les gains ult?rieurs comptent moins. Cela maintient la concurrence ?quitable si quelqu'un joue toute la journ?e.\n\n## Niveaux\n\nVotre niveau d?pend du total des XP permanents. Chaque niveau n?cessite un peu plus d'XP que le pr?c?dent (une courbe croissante), afin que le progr?s reste significatif.\n\nVotre profil montre combien d'XP vous avez dans le niveau actuel et combien il vous en faut pour le suivant.\n\n## Titres et rangs\n\nLes rangs sont des titres d?bloqu?s par niveau. Ils sont un signe de votre progression ? distincts des niveaux de ligue hebdomadaire.\n\n- Niveau 1 ? Esprit Curieux\n- Niveau 3 ? Explorateur\n- Niveau 5 ? Chercheur\n- Niveau 8 ? R?solveur de Probl?mes\n- Niveau 12 ? Analyste\n- Niveau 18 ? Logicien\n- Niveau 25 ? Strat?ge\n- Niveau 35 ? Polymathe\n- Niveau 50 ? G?nie\n- Niveau 70 ? Ma?tre du Savoir\n- Niveau 100 ? L?gende Procrastiq\n\n## Ligues hebdomadaires\n\nLes ligues sont une comp?tition hebdomadaire avec d'autres joueurs en groupes d'environ 20.\n\nNiveaux du plus bas au plus ?lev? :\n\n- Fer\n- Bronze\n- Argent\n- Or\n- Platine\n- Diamant\n- Ma?tre\n- L?gendaire\n\nChaque semaine, vous concourez pour l'XP class?e au sein de votre groupe. ? la fin de la semaine, les meilleurs joueurs sont promus d'un rang et les joueurs en bas de classement sont rel?gu?s d'un rang. Les autres restent.\n\nVous n'avez pas besoin d'attendre la r?initialisation du lundi pour rejoindre. Lorsque vous devenez ?ligible, vous ?tes plac? imm?diatement dans un groupe ouvert ? ou un nouveau groupe est cr?? pour vous.\n\nPour d?bloquer les ligues, vous devez g?n?ralement :\n\n- avoir au moins 100 XP permanents\n- avoir termin? au moins 10 activit?s\n- avoir particip? au moins 2 jours diff?rents\n- avoir la visibilit? du classement activ?e pour votre profil\n\nOuvrez la page des Classements ou votre panneau de statistiques ? tout moment pour voir votre rang, position et groupe."
        },
        "creator_progression": {
            "title": "XP et rangs de Cr?ateur",
            "content": "Cr?er du contenu sur ProcrastiQ a sa propre progression ? totalement s?par?e de l'XP des joueurs, des niveaux et des ligues hebdomadaires.\n\nLorsque les gens appr?cient vos quiz et d?fis intellectuels, vous gagnez de l'XP Cr?ateur (CXP). La CXP d?bloque les rangs de cr?ateur et vous place dans les classements des Contributeurs.\n\n## Deux syst?mes ind?pendants\n\n- Progression des joueurs ? XP obtenue en jouant, niveaux, rangs, ligues hebdomadaires\n- Progression des cr?ateurs ? CXP obtenue en contribuant du contenu de qualit?, rangs de cr?ateurs, tableaux des Contributeurs\n\nJouer n'augmente pas votre rang de cr?ateur. Cr?er n'augmente pas votre niveau de joueur. Vous pouvez progresser sur les deux pistes en m?me temps.\n\n## Comment vous gagnez de l'XP Cr?ateur\n\nLa CXP est attribu?e pour les contributions approuv?es et pour l'engagement sur ce contenu ? pas pour le nombre de brouillons que vous soumettez.\n\nR?compenses typiques :\n\n- Contenu approuv? ? +20 CXP (une fois par ?l?ment)\n- Tous les 10 compl?tions sur votre contenu ? +2 CXP\n- Tous les 10 likes sur votre contenu ? +5 CXP\n- Tous les 10 favoris sur votre contenu ? +2 CXP\n\nLes vues et autres statistiques sont suivies sur votre profil de cr?ateur, mais seules les r?compenses ci-dessus accordent des CXP. Les valeurs peuvent ?tre ajust?es au fil du temps.\n\n## Classes des cr?ateurs\n\nVotre niveau de cr?ateur provient du total de CXP. Les seuils augmentent de mani?re approximativement exponentielle, donc la progression initiale semble rapide et les niveaux sup?rieurs restent significatifs.\n\n- 0 CXP ? Contributeur\n- 50 CXP ? Cr?ateur\n- 150 CXP ? Auteur\n- 400 CXP ? Expert\n- 1 000 CXP ? Mentor\n- 2 500 CXP ? Cr?ateur Ma?tre\n- 6 000 CXP ? Sage Procrastiq\n\nVotre profil montre votre niveau actuel, votre CXP et votre progression vers le niveau suivant.\n\n## Classements des contributeurs\n\nLes cr?ateurs sont class?s par CXP, et non par nombre de contributions.\n\n- Hebdomadaire ? CXP gagn? cette semaine\n- Mensuel ? CXP gagn? ce mois-ci\n- Tous temps ? CXP total\n\nOuvrez les classements et passez aux Contributeurs pour voir qui progresse."
        }
    },
    "account": {
        "profile_picture": "Photo de profil",
        "save_changes": "Enregistrer les modifications",
        "update_success": "Profil mis ? jour avec succ?s",
        "update_failed": "?chec de la mise ? jour du profil",
        "country": "Pays",
        "avatar": {
            "upload_label": "T?l?verser l'avatar",
            "upload_success": "Avatar t?l?vers? avec succ?s",
            "upload_failed": "?chec du t?l?versement de l'avatar",
            "delete_confirm": "?tes-vous s?r de vouloir supprimer votre avatar ?",
            "delete_success": "Avatar supprim? avec succ?s",
            "delete_failed": "?chec de la suppression de l'avatar"
        },
        "password": {
            "set_optional": "D?finir le mot de passe (optionnel)",
            "change_optional": "Changer le mot de passe (optionnel)",
            "oauth_info": "Vous vous ?tes connect? avec {{method}}. Vous pouvez ?ventuellement d?finir un mot de passe pour activer la connexion par email/mot de passe.",
            "current": "Mot de passe actuel",
            "current_placeholder": "Entrez le mot de passe actuel",
            "current_required": "Le mot de passe actuel est requis pour changer le mot de passe",
            "new": "Nouveau mot de passe",
            "set_placeholder": "D?finir un mot de passe",
            "leave_blank_placeholder": "Laissez vide pour conserver l'actuel",
            "confirm": "Confirmer le nouveau mot de passe",
            "confirm_placeholder": "Confirmer le nouveau mot de passe",
            "mismatch": "Les nouveaux mots de passe ne correspondent pas"
        }
    },
    "play": {
        "label": "Play",
        "games": {
            "focus": "Focus",
            "reflex": "R?flexe",
            "memory": "M?moire",
            "sequence": "S?quence",
            "switch": "Switch",
            "rotate": "Rotation",
            "reason": "Raisonnement"
        },
        "actions": {
            "check": "Check",
            "continue": "Continue",
            "start": "Start"
        },
        "countdown": {
            "go": "Go !"
        },
        "intro": {
            "what": "De quoi il s?agit",
            "why": "Pourquoi on le propose",
            "how": "Que faire"
        },
        "focus": {
            "start_hint": "Remember the highlighted targets, track them as they move, then tap them again.",
            "hint_preview": "Remember these {{n}} targets.",
            "hint_track": "Keep tracking them?",
            "hint_select": "Tap the targets you tracked.",
            "arena": "Tracking area",
            "object": "Object {{n}}"
        },
        "reflex": {
            "progress": "{{current}} / {{total}}",
            "tap": "Response pad",
            "go": "TAP",
            "nogo": "WAIT",
            "rules": {
                "skip_red": {
                    "hint": "Tape vert ou bleu. Ne tape pas le rouge.",
                    "countdown_hint": "Pr?pare-toi ? tape vert ou bleu, ignore le rouge."
                },
                "skip_green": {
                    "hint": "Tape rouge ou bleu. Ne tape pas le vert.",
                    "countdown_hint": "Pr?pare-toi ? tape rouge ou bleu, ignore le vert."
                },
                "skip_blue": {
                    "hint": "Tape vert ou rouge. Ne tape pas le bleu.",
                    "countdown_hint": "Pr?pare-toi ? tape vert ou rouge, ignore le bleu."
                }
            }
        },
        "memory": {
            "countdown_hint": "Pr?pare-toi ? m?morise le motif, puis les changements.",
            "countdown_hint_stream": "Pr?pare-toi ? m?morise seulement les derniers symboles.",
            "hint_preview": "Remember which squares are on.",
            "hint_on": "Square {{n}} ON",
            "hint_off": "Square {{n}} OFF",
            "hint_final": "Recreate the final pattern.",
            "hint_stream": "Watch the symbols?",
            "hint_last_n": "Tap the last {{n}} symbols in order.",
            "intro": {
                "tagline": "Garde une info en tete un instant, puis utilise-la apres un court d?lai.",
                "what": "Un court exercice de m?moire de travail : m?morise un motif ou des symboles r?cents, puis reconstitue-les.",
                "why": "La m?moire de travail soutient la concentration et l?apprentissage ? une pratique breve entretient la comp?tence sans longs drills.",
                "how": "Observe bien, attends les changements ou le flux, puis tape ta r?ponse. La pr?cision compte plus que la vitesse."
            }
        },
        "sequence": {
            "countdown_hint": "Get ready ? the sequence is about to start.",
            "hint_watch_forward": "Watch the sequence.",
            "hint_watch_reverse": "Watch ? you will repeat it backwards.",
            "hint_watch_filter": "Watch ? remember only the blue items.",
            "hint_watch_interference": "Watch carefully.",
            "hint_distract": "?",
            "hint_input_forward": "Repeat the sequence.",
            "hint_input_reverse": "Enter it in reverse.",
            "hint_input_filter": "Enter only the blue items.",
            "hint_input_interference": "Now repeat the sequence.",
            "progress": "{{current}} / {{total}}",
            "pad": "Pad {{n}}",
            "pads": "Sequence pads"
        },
        "switch": {
            "start_hint": "Follow the current rule (color or shape) and pick the matching answer. The rule can change.",
            "rule": "Rule: {{rule}}",
            "progress": "{{current}} / {{total}}",
            "rules": {
                "color": "COLOR",
                "shape": "SHAPE"
            },
            "options": {
                "red": "Red",
                "blue": "Blue",
                "green": "Green",
                "circle": "Circle",
                "square": "Square",
                "triangle": "Triangle"
            }
        },
        "rotate": {
            "start_hint": "Is the right shape the same as the left one, only rotated? Yes or no.",
            "hint": "Same shape, only rotated?",
            "progress": "{{current}} / {{total}}",
            "reference": "Reference shape",
            "comparison": "Comparison shape",
            "yes": "Yes",
            "no": "No"
        },
        "reason": {
            "progress": "{{current}} / {{total}}",
            "modes": {
                "operators": "Operators",
                "running_total": "Running total",
                "number_relations": "Relations",
                "balance": "Balance"
            },
            "start_hints": {
                "operators": "Choose the operators that make the equation correct.",
                "running_total": "Add the numbers as they appear. Then pick the total sum.",
                "number_relations": "Find the number that matches the given rule for the target.",
                "balance": "Use the equations to find each shape’s value, then solve the missing result."
            },
            "operators": {
                "prompt": "Choose the correct equation."
            },
            "running_total": {
                "progress": "Sequence {{current}} / {{total}}",
                "watch": "Add the numbers as they appear.",
                "ask": "What is the sum of all shown numbers?"
            },
            "relations": {
                "square": "Which number is the square of {{n}}?",
                "square_root": "Which number is the square root of {{n}}?",
                "double": "Which number is double {{n}}?",
                "half": "Which number is half of {{n}}?",
                "triple": "Which number is triple {{n}}?",
                "one_third": "Which number is one third of {{n}}?",
                "next_multiple": "Which number is the next multiple of {{step}} after {{n}}?",
                "simple_difference": "Which number is {{step}} less than {{n}}?"
            },
            "balance": {
                "prompt": "What is the missing value?"
            }
        },
        "result": {
            "success": "Nice!",
            "finished": "Done",
            "fail": "? Wrong.",
            "score": "Score {{n}}",
            "accuracy": "{{n}}% accuracy",
            "level": "Level {{n}}",
            "personal_best": "New personal best",
            "level_unlocked": "Level {{n}} unlocked",
            "level_adjusted": "Difficulty adjusted"
        }
    },

    "pause": {
        "label": "Pause",
        "start": "Commencer",
        "skip": "Passer",
        "skip_step": "Passer cette etape",
        "continue": "Continuer",
        "why_this_works": "Pourquoi ca marche",
        "research": "Voir la recherche",
        "continue_to_duration": "Choisir la dur?e",
        "intro": {
            "what": "De quoi il s agit",
            "why": "Pourquoi on le propose",
            "how": "Comment faire"
        },
        "protocols": {
            "paced_breathing": {
                "name": "Ralentir",
                "tagline": "Ralentis ta respiration sur un rythme regulier.",
                "what": "Cinq secondes a l inspiration, cinq a l expiration, guide par un cercle qui grandit et se retracte.",
                "why": "La respiration lente et reguliere est l un des moyens les plus etudies pour redescendre apres un travail concentre.",
                "how": "Inspire par le nez pendant que le cercle grandit, expire pendant qu il se retracte. Reste a l aise.",
                "safety": "Ne force jamais ta respiration. Si tu as la tete qui tourne, arrete et respire normalement."
            },
            "cyclic_sigh": {
                "name": "Reset profond",
                "tagline": "Double inspiration, puis une longue expiration.",
                "what": "Deux inspirations par le nez puis une expiration plus lente par la bouche, en boucle.",
                "why": "C est la longue expiration que la plupart des gens decrivent comme apaisante, et elle a ete etudiee comme pratique respiratoire breve.",
                "how": "Inspire, ajoute une courte seconde inspiration, puis laisse l air sortir lentement par la bouche.",
                "safety": "Respire toujours en douceur et passe cet exercice si tu te sens etourdi."
            },
            "progressive_release": {
                "name": "Rel?cher",
                "tagline": "Contracte un groupe musculaire, puis relache.",
                "what": "Tu parcours quelques groupes musculaires, en contractant brievement chacun avant de le relacher.",
                "why": "Le contraste entre tension et relachement aide a reperer ou tu retenais de la tension.",
                "how": "Contracte doucement la zone annoncee, relache completement, puis observe la difference.",
                "safety": "Contracte seulement legerement et evite toute zone douloureuse ou blessee."
            },
            "nature_restore": {
                "name": "Restaurer",
                "tagline": "Repose tes yeux sur une scene naturelle calme.",
                "what": "Un court clip de nature sans son, a regarder au lieu de ton travail.",
                "why": "Regarder des scenes naturelles est une facon courante d offrir une pause a l attention dirigee.",
                "how": "Regarde, simplement. Laisse ton regard se detendre et suis ce qui bouge.",
                "safety": "Si un ecran de plus n est pas la pause qu il te faut, passe et regarde plutot par la fenetre."
            }
        },
        "duration": {
            "prompt": "Combien de temps as-tu ?",
            "short": "Courte",
            "recommended": "Recommandee",
            "seconds": "{{n}} s",
            "minutes": "{{n}} min"
        },
        "breathing": {
            "inhale": "Inspire",
            "exhale": "Expire"
        },
        "cyclic": {
            "inhale": "Inspire",
            "topup": "Ajoute une courte inspiration",
            "exhale": "Longue expiration"
        },
        "release": {
            "tense": "Contracte doucement : {{group}}",
            "release": "Relache",
            "notice": "Observe la difference",
            "steps": {
                "hands": "Mains",
                "forearms": "Avant-bras",
                "hands_forearms": "Mains et avant-bras",
                "shoulders": "?paules",
                "shoulders_back": "?paules et haut du dos",
                "face": "Visage et m?choire",
                "face_jaw": "Visage et m?choire",
                "upper_back": "Haut du dos",
                "back": "Dos",
                "belly": "Ventre",
                "legs": "Jambes",
                "feet": "Pieds",
                "legs_feet": "Jambes et pieds",
                "arms": "Bras"
            }
        },
        "nature": {
            "hint": "Laisse tes yeux se poser sur la scene.",
            "unavailable": "Aucun clip nature n est encore disponible.",
            "scenes": {
                "scene_01": "Scene naturelle calme",
                "scene_02": "Scene naturelle calme",
                "scene_03": "Scene naturelle calme",
                "scene_04": "Scene naturelle calme",
                "scene_05": "Scene naturelle calme",
                "scene_06": "Scene naturelle calme",
                "scene_07": "Scene naturelle calme",
                "scene_08": "Scene naturelle calme"
            }
        },
        "complete": {
            "title": "Termine"
        },
        "feedback": {
            "prompt": "Est-ce que ca a aide ?",
            "yes": "Oui",
            "a_little": "Un peu",
            "no": "Pas vraiment"
        }
    },

    "content": {
        "loading": "Chargement...",
        "no_content": "Aucun contenu pour le moment.",
        "feed_exhausted_tag": "Vous avez d?j? r?pondu ? tout pour cette ?tiquette",
        "feed_exhausted_category": "Vous avez d?j? r?pondu ? tout pour cette cat?gorie",
        "browse_feed": "Parcourir le fil de contenu",
        "back_to_feed": "? Retour au fil",
        "back": "? Retour",
        "content_not_found": "Contenu non trouv?",
        "failed_load": "?chec du chargement du contenu",
        "failed_load_more": "?chec du chargement de plus",
        "list": {
            "showing": "Affichage de {{count}} sur {{total}}",
            "load_more": "Charger plus"
        },
        "answer": {
            "your_answer": "Votre r?ponse...",
            "your_result_or_answer": "Votre r?sultat ou r?ponse...",
            "select_or_type": "S?lectionnez votre r?ponse...",
            "fill_in_blank": "Remplissez le blanc...",
            "your_answer_flip": "Votre r?ponse (ou retour pour v?rifier)...",
            "reveal_answer": "R?v?ler la r?ponse",
            "self_check_prompt": "Le saviez-vous ?",
            "knew_it": "Je le savais",
            "need_practice": "Besoin de plus de pratique",
            "check": "V?rifier",
            "completed": "Termin?",
            "completing": "Enregistrement...",
            "skip": "Passer",
            "next": "Suivant",
            "checking": "V?rification...",
            "correct": "? Correct !",
            "not_quite": "? Pas tout ? fait.",
            "correct_answer": "R?ponse correcte : {{answer}}"
        },
        "stats": {
            "sign_in_to_react": "Connectez-vous pour aimer ou ne pas aimer",
            "bookmark": "Ajouter aux favoris",
            "remove_bookmark": "Supprimer des favoris",
            "save_for_later": "Enregistrer pour plus tard",
            "saved": "Enregistr?",
            "share": "Partager",
            "link_copied": "Lien copi? dans le presse-papiers",
            "share_failed": "Impossible de partager ce quiz",
            "completions": "Completions : {{count}}",
            "aria_like": "Aimer",
            "aria_dislike": "Ne pas aimer"
        },
        "admin": {
            "edit": "Modifier",
            "delete": "Supprimer",
            "stats": "Statistiques",
            "stats_title": "Statistiques du contenu",
            "delete_confirm": "Supprimer ? {{title}} ? ?",
            "deleted": "Contenu supprim?",
            "delete_failed": "?chec de la suppression du contenu",
            "load_failed": "?chec du chargement du contenu",
            "id": "ID",
            "slug": "Slug",
            "status": "Statut",
            "locale": "Langue",
            "likes": "J'aime",
            "dislikes": "Je n'aime pas",
            "completions": "Compl?tions",
            "open_in_admin": "Ouvrir dans l'admin"
        },
        "difficulty": {
            "label": "Difficult? : {{value}}/{{max}}",
            "value": "{{value}}/{{max}}",
            "aria": "Difficult? {{value}} sur {{max}}"
        },
        "detail": {
            "sign_in_to_answer": "Connectez-vous pour r?pondre ? cette question.",
            "duration": "Dur?e : {{minutes}} min",
            "phase": "Phase {{number}}"
        },
        "list_item": {
            "completions": "{{count}} completions",
            "completions_label": "Completions : {{count}}"
        },
        "feed": {
            "success": "Correct ! ??",
            "skip": "Passer",
            "next": "Suivant",
            "intro_gate": {
                "title": "Connecte-toi pour continuer",
                "body": "Connecte-toi ou cr?e un compte et Procrastiq s?adapte a ce que tu aimes.",
                "body_more": "Il ne r?p?tera pas inutilement les memes questions, m?morisera tes r?sultats et te proposera du contenu selon tes centres d?int?ret.",
                "perks": "Tu auras aussi acces aux XP, ligues, Survival, d?fis avec d?autres joueurs et plus encore.",
                "register": "Cr?er un compte",
                "login": "Se connecter"
            }
        }
    },
    "categories": {
        "title": "Cat?gories",
        "filter": "Filtrer par cat?gorie",
        "all": "Tout",
        "loading": "Chargement des cat?gories...",
        "empty": "Aucune cat?gorie",
        "expand": "D?velopper les sous-cat?gories",
        "collapse": "R?duire les sous-cat?gories"
    },
    "tags": {
        "title": "Tags",
        "all": "Tout",
        "loading": "Chargement des tags...",
        "empty": "Aucun tag"
    },
    "bookmarks": {
        "title": "Favoris enregistr?s",
        "empty": "Aucun contenu enregistr? pour le moment."
    },
    "contribute": {
        "title": "Contribuer",
        "subtitle": "Soumettez des quiz pour r?vision. Une fois approuv?s, ils apparaissent dans le fil.",
        "subtitle_reliable": "Vous ?tes un contributeur fiable ? vos quiz sont publi?s imm?diatement.",
        "add": "+ Soumettre un quiz",
        "add_first": "Soumettez votre premier quiz",
        "empty": "Vous n'avez encore soumis aucun contenu.",
        "load_failed": "?chec du chargement de votre contenu",
        "cannot_edit_approved": "Le contenu approuv? ne peut ?tre modifi? que par un administrateur.",
        "delete_confirm": "Supprimer \"{{title}}\" ?",
        "deleted": "Contenu supprim?",
        "delete_failed": "?chec de la suppression du contenu",
        "edit": "Modifier",
        "delete": "Supprimer",
        "form": {
            "submit_title": "Soumettre un quiz",
            "edit_title": "Modifier votre quiz",
            "submit_button": "Soumettre pour r?vision",
            "save_button": "Enregistrer les modifications",
            "hint": "Votre quiz sera r?vis? avant d'appara?tre dans le flux. Les contributeurs fiables sont publi?s imm?diatement.",
            "success_updated": "Contenu mis ? jour avec succ?s",
            "success_published": "Contenu publi? avec succ?s",
            "success_submitted": "Contenu soumis pour r?vision",
            "success_created": "Contenu cr?? avec succ?s",
            "success_translation": "Traduction cr??e avec succ?s",
            "failed": "Impossible de {{action}} le contenu",
            "action_update": "mettre ? jour",
            "action_create": "cr?er",
            "choose_translation_language": "Choisissez une langue pour la traduction.",
            "admin_add": "Ajouter du contenu",
            "admin_edit": "Modifier le contenu",
            "admin_add_translation": "Ajouter une traduction",
            "admin_add_translation_lang": "Ajouter une traduction {{lang}}",
            "admin_create": "Cr?er du contenu",
            "admin_update": "Mettre ? jour le contenu",
            "admin_create_translation": "Cr?er une traduction"
        }
    },
    "content_form": {
        "title": "Titre",
        "slug": "Slug",
        "language": "Langue",
        "difficulty": "Difficult? (1?5)",
        "country": "Pays",
        "status": "Statut",
        "visibility": "Visibilit?",
        "categories": "Cat?gories",
        "tags": "?tiquettes",
        "translations": "Traductions",
        "translation_new": "(nouveau)",
        "translate_hint": "Traduire la question, les options et l'explication. Les m?tadonn?es (difficult?, cat?gories, ?tiquettes) sont copi?es depuis la source.",
        "choose_language": "Choisir la langue",
        "not_set": "Non d?fini",
        "description": "Description",
        "description_placeholder": "Description de la question ou de la t?che",
        "options": "Options",
        "option_n": "Option {{n}}",
        "add_option": "+ Ajouter une option",
        "remove": "Supprimer",
        "correct_answer": "R?ponse correcte",
        "explanation": "Explication",
        "explanation_placeholder": "Optionnel ? affich? apr?s une r?ponse incorrecte"
    },
    "user_stats": {
        "title": "Vos statistiques",
        "sign_in_prompt": "Connectez-vous pour voir vos statistiques",
        "guest_title": "Classement. Montez de niveau. Gravissez les ligues.",
        "guest_lead": "Suivez les XP, d?bloquez les grades de titre et participez aux ligues hebdomadaires une fois connect?.",
        "guest_perk_level": "Gagnez des XP avec les quiz et progressez dans les niveaux.",
        "guest_perk_rank": "D?bloquez les grades de titre ? mesure que votre niveau augmente.",
        "guest_perk_league": "Rejoignez les groupes hebdomadaires et progressez vers L?gendaire.",
        "xp": "XP",
        "streak": "S?rie",
        "best_streak": "Meilleure s?rie",
        "solved": "R?pondu",
        "correct": "Correct",
        "accuracy": "Pr?cision",
        "bookmarks": "Favoris",
        "contribute": "Contribuer",
        "likes": "J'aime",
        "language_mastered": "Ma?tris?",
        "language_learning": "En apprentissage",
        "last_7_days": "Derniers 7 jours",
        "days_suffix": "j",
        "no_activity": "Aucune activit? pour le moment",
        "weekly_league": "Ligue hebdomadaire",
        "league_tiers": "Niveaux de ligue",
        "league_tiers_hint": "Des niveaux du plus bas au plus haut. Terminez en t?te de votre groupe pour monter ; les derniers rel?guent. ",
        "league_position": "#{{position}} de {{total}} cette semaine",
        "view_leaderboard": "Plateau complet",
        "how_leagues_work": "Comment ?a fonctionne",
        "you": "Toi"
    },
    "gamification": {
        "level": "Niveau",
        "rank": "Grade",
        "streak": "S?rie",
        "daily_goals": "Objectifs quotidiens",
        "achievements": "R?alisations",
        "leaderboard": "Classement",
        "season": "Saison",
        "xp_to_next": "{{current}} / {{next}} XP pour passer au niveau sup?rieur",
        "weekly": "Hebdomadaire",
        "monthly": "Ce mois-ci",
        "overall": "Globalisation",
        "monthly_hint": "Classe les joueurs par XP class?e gagn?e pendant la saison du mois civil en cours (m?mes rendements d?croissants que les ligues hebdomadaires). Ce n?est pas un niveau de ligue distinct. ",
        "overall_hint": "Classement de tous les temps par XP total permanent. ",
        "overall_empty": "Aucun joueur sur le tableau g?n?ral pour l?instant. ",
        "players": "Membres",
        "full_board": "Plateau complet",
        "player": "Membre",
        "ranked_xp": "XP class?e",
        "total_xp": "Total XP",
        "standing": "Debout",
        "zone": "Debout",
        "zone_promotion": "Promotion",
        "zone_safe": "C?est s?r",
        "zone_relegation": "Rel?gation",
        "zone_legend": "Top {{promo}} promouvoir ? Bottom {{releg}} rel?gu? en fin de week-end. ",
        "unlocked": "D?bloqu?",
        "achievements_error": "?chec du chargement des succ?s",
        "achievements_intro": "D?bloquez des badges au fur et ? mesure du jeu ? activit?, pr?cision, s?ries, difficult? et apprentissage des erreurs. ",
        "achievement_categories": {
            "activity": "Activit?",
            "correct_answers": "Bonnes r?ponses",
            "learning_from_mistakes": "Apprendre des erreurs",
            "streaks": "S?ries",
            "difficulty": "Difficult?",
            "variety": "Vari?t?",
            "general": "G?n?ralit?s"
        },
        "achievement_category_hints": {
            "learning_from_mistakes": "Apr?s une mauvaise r?ponse, ce quiz peut revenir plus tard pour ?tre r?vis?. R?pondre correctement compte alors ici. "
        },
        "your_rank": "Votre grade",
        "around_you": "Autour de toi",
        "tooltip_total_xp": "{{xp}} XP totale",
        "tooltip_level": "Niveau {{level}}",
        "weekly_waiting": "Impossible de charger votre groupe hebdomadaire. Veuillez r?essayer. ",
        "weekly_ineligible": "Continuez ? jouer pour d?bloquer des ligues hebdomadaires. ",
        "achievements_progress": "{{unlocked}} / {{total}} d?bloqu?",
        "toast": {
            "xp_gained": "+{{xp}} XP",
            "achievement": "Succ?s d?bloqu? : {{name}}"
        },
        "level_up": {
            "title": "Monte de niveau ! ",
            "body": "Tu as atteint le niveau {{level}}",
            "continue": "Continue"
        }
    },
    "creator": {
        "rank": "Rang de cr?ateur",
        "xp": "XP de cr?ateur",
        "tooltip_rank": "{{rank}}",
        "tooltip_cxp": "{{xp}} CXP",
        "approved": "Contributions approuv?es",
        "views": "Vues",
        "completions": "Ach?vements",
        "likes": "J?aime",
        "bookmarks": "Signets",
        "top_contribution": "Contribution principale",
        "newest_contribution": "Derni?re contribution",
        "to_next": "au rang suivant",
        "players_board": "Membres",
        "creators_board": "Contributeurs",
        "board_group": "Type de classement",
        "weekly": "Hebdomadaire",
        "monthly": "Mensuel",
        "all_time": "Depuis toujours",
        "weekly_hint": "Cr?ateurs class?s selon le XP de cr?ateur obtenu cette semaine.",
        "monthly_hint": "Cr?ateurs class?s selon le XP de cr?ateur obtenu ce mois.",
        "all_time_hint": "Classement depuis toujours par XP de cr?ateur.",
        "empty": "Aucun cr?ateur sur le tableau pour le moment."
    },
    "profile": {
        "title": "Mon profil",
        "edit": {
            "title": "Modifier le profil"
        },
        "nav": {
            "label": "Compte",
            "overview": "Aper?u",
            "stats": "Statistiques",
            "leagues": "Ligues",
            "edit": "Modifier le profil",
            "contribute": "Contribuer",
            "bookmarks": "Favoris",
            "achievements": "R?alisations",
            "leaderboards": "Classements",
            "browse": "Parcourir le contenu"
        },
        "actions": {
            "back_to_home": "Retour ? l'accueil",
            "back_to_profile": "Retour au profil",
            "edit": "Modifier le profil",
            "contribute": "Contribuer"
        },
        "labels": {
            "initials": "Initiales",
            "role": "R?le",
            "status": "Statut",
            "sign_in_method": "M?thode de connexion",
            "member_since": "Membre depuis",
            "country": "Pays",
            "reliable": "Contributeur fiable"
        },
        "sections": {
            "account_info": "Informations du compte",
            "authentication": "Authentification",
            "creator": "Cr?ateur",
            "stats": "Vos statistiques",
            "leagues": "Ligues hebdomadaires"
        },
        "stats": {
            "title": "Statistiques",
            "subtitle": "Votre progression, activit? et ligue hebdomadaire en un coup d'?il.",
            "empty": "Pas encore de statistiques. Jouez ? quelques quiz pour commencer.",
            "periods": "Aujourd'hui & cette semaine",
            "today": "Aujourd'hui",
            "see_all": "Toutes les statistiques",
            "see_leagues": "Ouvrir la page des ligues"
        },
        "leagues": {
            "title": "Ligues",
            "subtitle": "Votre niveau de ligue hebdomadaire, classement du groupe, et zone de promotion ou de rel?gation.",
            "your_group": "Votre groupe cette semaine",
            "see_all": "Ouvrir les ligues"
        }
    },
    "notifications": {
        "title": "Notifications",
        "hint": "Recevez des alertes sur votre s?rie, position dans la ligue, et votre contenu ? m?me lorsque Procrastiq est ferm?.",
        "enable": "Activer les notifications",
        "disable": "D?sactiver sur cet appareil",
        "enabled": "Notifications activ?es",
        "disabled": "Notifications d?sactiv?es sur cet appareil",
        "enable_failed": "Impossible d'activer les notifications",
        "disable_failed": "Impossible de d?sactiver les notifications",
        "prefs_failed": "Impossible d'enregistrer les pr?f?rences",
        "unsupported": "Les notifications push ne sont pas prises en charge dans ce navigateur.",
        "pref_ranking": "Ligue & classement",
        "pref_streak": "S?rie",
        "pref_reactions": "R?actions ? mon contenu",
        "pref_approved": "Approbation du contenu"
    },
    "games": {
        "challenge_friend": "Challenge a friend",
        "survival_mode": "Survival",
        "challenges_inbox": "Challenges",
        "view_inbox": "View inbox",
        "pick_friend": "Pick a friend",
        "random_opponent": "Random opponent",
        "search_users": "Search by name?",
        "search_error": "Could not search users",
        "selected": "Selected",
        "selected_opponent": "Selected player",
        "pick_opponent": "Pick an opponent first",
        "random_hint": "We'll match you with an active player.",
        "any_category": "Any category",
        "category_optional": "Category (optional)",
        "start_challenge": "Send challenge",
        "challenge_created": "Challenge sent!",
        "create_error": "Could not create challenge",
        "challenge": "Challenge",
        "open": "Open",
        "new_challenge": "New challenge",
        "start_playing": "Start playing",
        "accept_play": "Accept & play",
        "decline": "Decline",
        "decline_error": "Could not decline challenge",
        "your_result": "Your result",
        "opponent_result": "Opponent",
        "waiting_opponent": "Waiting for your opponent to finish?",
        "score_line": "{{correct}}/{{total}} correct ? {{time}}",
        "you_won": "You won!",
        "you_lost": "You lost",
        "draw": "It's a draw",
        "submitting": "Submitting answers?",
        "submit_error": "Could not submit challenge",
        "load_error": "Could not load",
        "not_found": "Challenge not found",
        "no_challenges": "No challenges yet",
        "incoming": "Incoming",
        "outgoing": "Outgoing",
        "player": "Player",
        "filter": {
            "incoming": "Incoming",
            "outgoing": "Outgoing",
            "all": "All"
        },
        "status": {
            "pending": "Pending",
            "in_progress": "In progress",
            "completed": "Completed",
            "declined": "Declined",
            "expired": "Expired"
        },
        "question_progress": "Question {{current}} / {{total}}",
        "time_left": "{{seconds}}s",
        "elapsed_time": "Time {{time}}",
        "overall_time": "Total time",
        "total_time_left": "Total {{seconds}}s",
        "no_options": "No answer options for this question",
        "survival_leaderboard": "Survival leaderboard",
        "survival_leaderboard_hint": "Best survival run per player in the selected period.",
        "survival_empty": "No survival scores yet ? be the first!",
        "play_survival": "Play Survival",
        "current_score": "Score: {{score}}",
        "game_over": "Game over",
        "final_score": "You scored {{score}}",
        "personal_best": "Personal best: {{score}}",
        "daily_rank": "Daily rank: #{{rank}}",
        "weekly_rank": "Weekly rank: #{{rank}}",
        "play_again": "Play again",
        "survival_start_error": "Could not start survival run",
        "survival_error": "Survival error",
        "daily": "Daily",
        "weekly": "Weekly",
        "all_time": "All time",
        "score": "Score",
        "challenge_user": "Challenge {{name}}",
        "login_to_challenge": "Log in to challenge this player",
        "profile_error": "Could not load profile",
        "profile_not_found": "Player not found",
        "profile": "Profile",
        "notifications": "Notifications",
        "mark_all_read": "Mark all read",
        "no_notifications": "No notifications",
        "blocked_users": "Blocked players",
        "blocked_hint": "Blocked players cannot challenge you.",
        "no_blocked": "You haven't blocked anyone.",
        "unblock": "Unblock",
        "unblocked": "Player unblocked",
        "unblock_error": "Could not unblock player",
        "blocked_load_error": "Could not load blocked players",
        "survival_howto": "R?pondez correctement le plus longtemps possible. Vous avez 20 secondes par question. Une mauvaise r?ponse est pardonn?e ? la deuxieme termine la partie. Votre score est le nombre de bonnes r?ponses.",
        "challenge_howto": "Dix questions, 20 secondes chacune. Plus de bonnes r?ponses et un temps plus court l'emportent. Vous verrez le r?sultat de votre adversaire une fois que vous aurez tous les deux termin?.",
        "continue": "Continuer",
        "survival_reserve": "R?serve : {{count}}",
        "survival_second_chance": "Deuxieme chance !",
        "guest_teaser": "Log in to challenge friends and climb Survival ranks."
    }
};
